// @ts-nocheck
// TODO: tighten types after migration
import React, { useMemo } from "react";
import CommentsPanel from "../components/comments/CommentsPanel";
import { createPodcastCommentsAdapter } from "../components/comments/adapters";
import "./PodcastThoughts.css";

export default function PodcastThoughts({ podcastId }) {
  const [token, setToken] = React.useState(() => sessionStorage.getItem("token"));

  React.useEffect(() => {
    const handleUpdate = () => setToken(sessionStorage.getItem("token"));
    window.addEventListener("userUpdated", handleUpdate);
    return () => window.removeEventListener("userUpdated", handleUpdate);
  }, []);

  const adapter = useMemo(() => {
    if (!podcastId) {
      return null;
    }
    return createPodcastCommentsAdapter(podcastId, token);
  }, [podcastId, token]);

  if (!podcastId || !adapter) {
    return null;
  }

  return (
    <CommentsPanel
      entityType="podcast"
      entityId={String(podcastId)}
      adapter={adapter}
      canComment={true}
      variant="podcast"
    />
  );
}
